const prefix = 'posfacil';

export const localStorageKeys = {
  DYNAMIC_SIDEBAR_DATA: `${prefix}-dynamic-sidebar`,
  INVENTORY_RECONCILIATION_STOCK_LOCAL: `${prefix}-inventory-reconciliation-stock-local`,
};
